import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export default function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", { style: {"width":"1em","height":"1em"} }, [
    _createElementVNode("use", { "xlink:href": "#call-received" })
  ]))
}